import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImgLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0ZM35 12.25C29.6843 12.25 25.375 16.5593 25.375 21.875C25.375 27.1907 29.6843 31.5 35 31.5C40.3157 31.5 44.625 27.1907 44.625 21.875C44.625 16.5593 40.3157 12.25 35 12.25Z",
		fill: "black"
	})
});
export default SvgImgLogo;
